import { render } from "./GoodsKeyring.vue?vue&type=template&id=3fdeb15a&scoped=true"
import script from "./GoodsKeyring.vue?vue&type=script&lang=js"
export * from "./GoodsKeyring.vue?vue&type=script&lang=js"

import "./GoodsKeyring.vue?vue&type=style&index=0&id=3fdeb15a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fdeb15a"]])

export default __exports__